import { memo } from 'react'
import { getFormattedUtcDate } from '@tabeeb/services/dateTimeService'
import { SearchStatus } from '@tabeeb/enums'
import CircularProgressBar from '@tabeeb/modules/shared/tabeebCircularProgressBar'
import { Tooltip, Stack, Button, Caption } from '@collaborate-health/uikit'
import { LockOutlined } from '@mui/icons-material'
import { useDispatch, useSelector } from '@tabeeb/store'
import { setSelectedTargetContentForMerging } from '@tabeeb/modules/sessionsPage/actions'
import {
  StyledContentDescriptionContainer,
  StyledContentDetailsContainer,
  StyledContentSearchResultContainer,
  StyledDescription,
  StyledSearchContentItemContainer,
  StyledThumbnail,
} from './TargetContentSearchResult.styles'

interface Content {
  Id: string
  Description: string
  OwnerName: string
  CreatedOn: string
  ThumbnailUrl?: string
  IsActive?: boolean
}

const TargetContentSearchResult = () => {
  const dispatch = useDispatch()
  const { list, status } = useSelector((state) => state.sessionsPage.targetContentSearchResult)

  if (list.length === 0) {
    if (status === SearchStatus.NotStarted) {
      return null
    }

    if (status === SearchStatus.Completed) {
      return <div>Session not found</div>
    }
  }

  return (
    <StyledContentSearchResultContainer>
      {status === SearchStatus.InProgress && <CircularProgressBar />}
      {list.map((content: Content) => (
        <StyledSearchContentItemContainer
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          key={content.Id}
        >
          <StyledContentDetailsContainer direction='row' spacing={1.5} key={content.Id}>
            <Stack direction='row' spacing={1} alignItems='center'>
              <StyledThumbnail
                src={content.ThumbnailUrl || '/Content/img/image_placeholder.png'}
                alt='Session preview'
              />
              {content.IsActive === false && (
                <Tooltip text='Expired'>
                  <LockOutlined />
                </Tooltip>
              )}
            </Stack>
            <StyledContentDescriptionContainer>
              <Tooltip text={content.Description}>
                <StyledDescription>{content.Description}</StyledDescription>
              </Tooltip>
              <Caption>{`Owner: ${content.OwnerName}`}</Caption>
              <Caption>{`Created on: ${getFormattedUtcDate(content.CreatedOn, 'MMM D, YYYY h:mm A')}`}</Caption>
            </StyledContentDescriptionContainer>
          </StyledContentDetailsContainer>
          <Button
            variant='outlined'
            color='primary'
            size='small'
            onClick={() => dispatch(setSelectedTargetContentForMerging(content))}
          >
            Select
          </Button>
        </StyledSearchContentItemContainer>
      ))}
    </StyledContentSearchResultContainer>
  )
}

export default memo(TargetContentSearchResult)

